import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { IGenericResponse, ILoginRequest, IRegisterRequest, IVerifyUserRequest } from 'state/interfaces';
import { User } from 'types/User';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_SERVER_ENDPOINT}/auth`, credentials: "include" }),
  endpoints: (builder) => ({
    login: builder.mutation<{user: User; accessToken: string}, ILoginRequest>({
      query: body => ({
        url: `login`,
        method: "POST",
        body,
      }),
      transformResponse: (results: IGenericResponse<{user: User; accessToken: string}>) => results.data,
    }),
    register: builder.mutation<string, IRegisterRequest>({
      query: body => ({
        url: `register`,
        method: "POST",
        body,
      }),
      transformResponse: (results: IGenericResponse<string>) => results.data,
    }),
    verifyEmail: builder.mutation<string, IVerifyUserRequest>({
      query: body => ({
        url: `/verify-email/${body.verificationCode}`,
        method: "PUT",
        body,
      }),
      transformResponse: (results: IGenericResponse<string>) => results.data,
    }),
    checkConnectedAccount: builder.query<string | false, void>({
      query: () => ({
        url: `/check-connectedAccount`,
      }),
      transformResponse: (results: IGenericResponse<string | false>) => results.data,
    }),
    setConnectedAccountChecked: builder.mutation<string | false, void>({
      query: () => ({
        url: `/connectedAccount-checked`,
        method: "PUT"
      }),
      transformResponse: (results: IGenericResponse<string | false>) => results.data,
    }),
  }),
});

export const {
    useLoginMutation,
    useRegisterMutation,
    useVerifyEmailMutation,
    useSetConnectedAccountCheckedMutation,
    useCheckConnectedAccountQuery
} = authApi;